



















import { Prop, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { ReferralAPI } from '@/api/backend-client'

@Component
export default class ReferralScore extends Vue {
    @Prop({ required: true }) readonly referral: Referral
    @Prop({ type: Boolean, required: false }) disabled: boolean
    updating: boolean = false

    classesForScore(score: number) {
        return {
            'choice--selectable': !this.disabled,
            'choice--selected': this.referral.score === score,
        }
    }

    async changeScore(score: number) {
        if (this.disabled || this.updating) {
            return
        }

        try {
            this.updating = true
            await ReferralAPI.updateScore(this.referral.id, score)
            this.$emit('score-changed', score)

        } finally {
            this.updating = false
        }
    }
}
